<div class="flex flex-col items-center p-8 bg-background-dark w-full">
    <h2>Mitwirkende:</h2>
    @for(version of contributors; track $index) {
        <h3 class="pt-2">{{ version.version }}</h3>
        <div class="flex flex-row flex-wrap gap-8">
            @for (contributor of version.contributors; track $index) {
                <p>{{ contributor.name }}, {{ contributor.firstName }}</p>
            }
        </div>
    }
</div>